import React, { Component } from "react";
import { oneOfType, node, string, bool, func } from "prop-types";
import classNames from "classnames";

class Radio extends Component {
    static propTypes = {
        checked: bool.isRequired,
        label: oneOfType([string, node]).isRequired,
        value: string.isRequired,
        className: string,
        mode: string,
        inLineControl: bool,
        name: string.isRequired,
        onChange: func.isRequired,
        id: string.isRequired,
        radioLabelClassName: string,
        disabled: bool,
        ariaLabelledby: string,
    };

    static defaultProps = {
        inLineControl: false,
        className: "",
        mode: "edit",
        radioLabelClassName: null,
        disabled: false,
        ariaLabelledby: null,
    };

    render() {
        const {
            id,
            inLineControl,
            value,
            name,
            checked,
            onChange,
            className,
            label,
            mode,
            radioLabelClassName,
            disabled,
            ariaLabelledby,
        } = this.props;

        if (mode !== "edit" && !checked) {
            return null;
        }

        if (mode !== "edit") {
            return <div>{label}</div>;
        }

        return (
            <div
                className={classNames(
                    "c-control",
                    "c-control--has-icon",
                    "c-control--radio",
                    "display-flex",
                    "gap-3",
                    "align-items-center",
                    "position-relative",
                    className,
                    {
                        "c-control-block": !inLineControl,
                    },
                )}>
                <div className="c-control-radio-input-wrap">
                    <input
                        {...(ariaLabelledby && { "aria-labelledby": classNames(ariaLabelledby, id) })}
                        className="c-control-input"
                        checked={checked}
                        id={id}
                        type="radio"
                        value={value}
                        onChange={onChange}
                        name={name}
                        disabled={disabled}
                    />
                    <div className="c-control-icons" aria-hidden="true">
                        <div className="c-control-mark">
                            <svg
                                className="c-control-radio-mark-svg"
                                viewBox="0 0 16 16"
                                xmlns="http://www.w3.org/2000/svg"
                                focusable="false"
                                aria-hidden="true">
                                <circle cx="8" cy="8" r="4" fill="currentColor" />
                            </svg>
                        </div>
                    </div>
                </div>
                <label htmlFor={id} className={classNames("c-control-label m-0", radioLabelClassName)}>
                    {label}
                </label>
            </div>
        );
    }
}

export default Radio;
